import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import _ from 'lodash'
import { message } from 'antd'

const service = new ApolloClientService()

export default class Event {
  getAllEvents = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getAllEvents(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  addEditEvent = (params, events) => {
    return new Promise((resolve, reject) => {
      service
        .addEditEvent(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            var updatedevents = this.modifyEvents(
              JSON.parse(JSON.stringify(events)),
              data,
              !params.event?._id
            )
            resolve({ events: updatedevents })
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  bulkAddEditEvent = (params) => {
    return new Promise((resolve, reject) => {
      service
        .bulkAddEditEvent(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  deleteEvent = (params, events) => {
    return new Promise((resolve, reject) => {
      service
        .deleteEvent(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            var evs = JSON.parse(JSON.stringify(events))
            evs.splice(_.findIndex(evs, { _id: params.event._id }), 1)
            resolve({ events: evs })
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  isEventUpdated = (params, events) => {
    return new Promise((resolve, reject) => {
      service
        .isEventUpdated(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  switchEventAutoImport = (params, flag) => {
    return new Promise((resolve, reject) => {
      service
        .switchAutoImport(params, flag)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getDifferences = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getDifference(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  importFromMaster = (params) => {
    return new Promise((resolve, reject) => {
      service
        .importFromMaster(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  discardEvents = (params) => {
    return new Promise((resolve, reject) => {
      service
        .discardEvents(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  modifyEvents = (events, event, newEvent = false) => {
    delete event.status
    if (newEvent) {
      events.push(event)
      return events
    } else if (!newEvent) {
      var index = _.findIndex(events, { _id: event._id })
      events[index] = event
      return events
    }
  }
}
